/**
 * @generated SignedSource<<200d5afd9ae19243f8f340ecbf6dc824>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubmitMultipleChoiceElementV2Input = {
  checkedAnswerIndices: ReadonlyArray<number>;
  clientMutationId?: string | null;
  contentSubmissionId: string;
  multipleChoiceElementId: string;
};
export type RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation$variables = {
  input: SubmitMultipleChoiceElementV2Input;
};
export type RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation$data = {
  readonly LearnV2: {
    readonly submitMultipleChoiceElement: {
      readonly contentSubmission: {
        readonly definition: {
          readonly progress?: {
            readonly percentage: number;
          };
        };
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"RightFrameContentSubmissionComponent_ContentSubmissionFragment">;
      };
    } | null;
  };
};
export type RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation = {
  response: RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation$data;
  variables: RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentage",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numElements",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elementType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = [
  (v8/*: any*/),
  (v3/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "file",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerOptionWithoutCorrect",
  "kind": "LinkedField",
  "name": "answerOptions",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answeringType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ELearningContentSubmissionRelativeProgress",
  "kind": "LinkedField",
  "name": "relativeProgress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numCorrect",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageCorrect",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAnswerExpired",
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasonConfigTypes",
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "extension",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "InfectopharmTreeConfigConsequences",
                  "kind": "LinkedField",
                  "name": "configConsequences",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showAnswerFrom",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "LearnOpportunityRootExtensionImpl",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LearnOpportunityRootStructureDefinition",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containedElementTypes",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "showAnswerElements",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AnswerOptionV2",
          "kind": "LinkedField",
          "name": "answerOptions",
          "plural": true,
          "selections": [
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCorrect",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "MultipleChoiceElementV2",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Mutations",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SubmitMultipleChoiceElementV2Payload",
            "kind": "LinkedField",
            "name": "submitMultipleChoiceElement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveELearningContentSubmissionDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RightFrameContentSubmissionComponent_ContentSubmissionFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Mutations",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SubmitMultipleChoiceElementV2Payload",
            "kind": "LinkedField",
            "name": "submitMultipleChoiceElement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAtLastElement",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentElementIndex",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ActiveELearningContentSubmissionProgress",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "currentElementState",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "element",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v7/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fileContentType",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "type": "FileLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "podcastSource",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sourceType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "podigeeUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "PodigeePodcastSourceV2",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleasedFileV2",
                                        "kind": "LinkedField",
                                        "name": "releasedFileOpt",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleasedSubtitlesV2",
                                        "kind": "LinkedField",
                                        "name": "releasedSubtitlesOpt",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SubtitlesV2",
                                            "kind": "LinkedField",
                                            "name": "subtitles",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SubtitleV2",
                                                "kind": "LinkedField",
                                                "name": "subtitles",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "startTime",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endTime",
                                                    "storageKey": null
                                                  },
                                                  (v12/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "type": "PodcastLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "type": "TextLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "videoFile",
                                        "plural": false,
                                        "selections": (v9/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SubtitlesForLanguage",
                                        "kind": "LinkedField",
                                        "name": "subtitles",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "VideoSubtitle",
                                            "kind": "LinkedField",
                                            "name": "subtitles",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "startTimeInSec",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "endTimeInSec",
                                                "storageKey": null
                                              },
                                              (v12/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "type": "VideoLearnElement",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/),
                                          (v17/*: any*/),
                                          (v16/*: any*/),
                                          (v18/*: any*/)
                                        ],
                                        "type": "MultipleChoiceLearnElement",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "UntouchedElementState",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v14/*: any*/),
                                          (v16/*: any*/)
                                        ],
                                        "type": "MultipleChoiceLearnElement",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "checkedAnswerIndices",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MultipleChoiceInputElementState",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canGoToPrevious",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "type": "FailedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rewardResults",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rewardKind",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pointsPoolName",
                                    "storageKey": null
                                  }
                                ],
                                "type": "PointsRewardWasPossibleResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "certificateName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IssuedCertificateV2",
                                    "kind": "LinkedField",
                                    "name": "issuedCertificate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "fileRef",
                                        "plural": false,
                                        "selections": (v9/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CertificateRewardWasPossibleResult",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PassedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "learnOpportunity",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "attachmentsV2",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fileType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accessType",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                  }
                                ],
                                "type": "InfectopharmFileAttachment",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "InfectopharmTreeConfigConsequences",
                                            "kind": "LinkedField",
                                            "name": "configConsequences",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "rewardExpired",
                                                "storageKey": null
                                              },
                                              (v20/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "LearnOpportunityRootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "viewerTreeState",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v21/*: any*/),
                                        "type": "CanNotBeStartedViewerTreeState",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "headContentId",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "IsStartedViewerTreeState",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "root",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "typeDefinition",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v23/*: any*/),
                                              (v24/*: any*/)
                                            ],
                                            "type": "LearnOpportunityELearningContentTypeDefinition",
                                            "abstractKey": null
                                          },
                                          (v25/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LearnOpportunityV2",
                                        "kind": "LinkedField",
                                        "name": "root",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityBranchTypeDefinition",
                                "abstractKey": null
                              },
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v24/*: any*/)
                                ],
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentConfigConsequences",
                                        "kind": "LinkedField",
                                        "name": "configConsequences",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "percentageRequiredToPass",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBlockedPermanentlyAfterNumFailedTries",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBlockedTemporarilyForNumDaysAfterOneFailedTry",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cmePoints",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "headFirstElementType",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnContentExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "contentNodeAdvancementResult",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "configResults",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "configType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isRestartIfFailedContentConfigResult"
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "canBeRestarted",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "blockedUntil",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "CanNotBeStartedContentNodeAdvancementResult",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "activeContentSubmissionId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ContinueContentNodeAdvancementResult",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "nextContentNode",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/)
                                ],
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortDescription",
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastUpdated",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f846156d0ee9c8446d4045038a140879",
    "id": null,
    "metadata": {},
    "name": "RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation",
    "operationKind": "mutation",
    "text": "mutation RightFrameMultipleChoiceElementPart_SubmitMultipleChoiceElementMutation(\n  $input: SubmitMultipleChoiceElementV2Input!\n) {\n  LearnV2 {\n    submitMultipleChoiceElement(input: $input) {\n      contentSubmission {\n        definition {\n          __typename\n          ... on ActiveELearningContentSubmissionDefinition {\n            progress {\n              __typename\n              percentage\n            }\n          }\n        }\n        id\n        ...RightFrameContentSubmissionComponent_ContentSubmissionFragment\n      }\n    }\n  }\n}\n\nfragment AttachmentCard_AttachmentFragment on InfectopharmFileAttachment {\n  id\n  file {\n    name\n    url\n    fileType\n    accessType\n    id\n  }\n  title\n  description\n}\n\nfragment AttachmentDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        ...AttachmentCard_AttachmentFragment\n      }\n      id\n    }\n  }\n}\n\nfragment ContentElementContainer_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      canGoToPrevious\n      progress {\n        __typename\n        percentage\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    ...AttachmentDisplay_LearnOpportunityV2Fragment\n  }\n}\n\nfragment FileElementDisplay_FileElementV2Fragment on FileLearnElement {\n  file {\n    url\n    id\n  }\n  fileContentType\n  title\n}\n\nfragment FileElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...FileElementDisplay_FileElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n}\n\nfragment NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  root {\n    id\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      definitionType\n      contentNodeAdvancementResult {\n        __typename\n        status\n        ... on CanNotBeStartedContentNodeAdvancementResult {\n          reasonConfigTypes\n        }\n        ... on ContinueContentNodeAdvancementResult {\n          activeContentSubmissionId\n        }\n        ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n          status\n          configResults {\n            __typename\n            configType\n            __isRestartIfFailedContentConfigResult: __typename\n            canBeRestarted\n            ... on NegativeBlockPermanentlyWhenRewardedRestartIfFailedContentConfigResult {\n              canBeRestarted\n            }\n            ... on NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult {\n              blockedUntil\n            }\n          }\n        }\n      }\n      containedElementTypes\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        viewerTreeState {\n          __typename\n          kind\n          ... on CanNotBeStartedViewerTreeState {\n            reasonConfigTypes\n          }\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n      containedElementTypes\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          cmePoints\n          headFirstElementType\n        }\n      }\n    }\n  }\n}\n\nfragment PodcastElementDisplay_PodcastElementV2Fragment on PodcastLearnElement {\n  podcastSource {\n    __typename\n    sourceType\n    ... on PodigeePodcastSourceV2 {\n      podigeeUrl\n    }\n  }\n  releasedFileOpt {\n    file {\n      url\n      id\n    }\n  }\n  releasedSubtitlesOpt {\n    subtitles {\n      subtitles {\n        startTime\n        endTime\n        text\n      }\n    }\n  }\n  title\n}\n\nfragment PodcastElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...PodcastElementDisplay_PodcastElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment ProjectContentElementContainer_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      canGoToPrevious\n      progress {\n        __typename\n        percentage\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    root {\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n      }\n    }\n    ...AttachmentDisplay_LearnOpportunityV2Fragment\n  }\n}\n\nfragment RightFrameContentElement_ContentSubmissionFragment on ContentSubmission {\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          elementType\n          id\n        }\n      }\n    }\n  }\n  ...FileElementPart_ContentSubmissionFragment\n  ...RightFrameMultipleChoiceElementPart_ContentSubmissionFragment\n  ...PodcastElementPart_ContentSubmissionFragment\n  ...TextElementPart_ContentSubmissionFragment\n  ...VideoElementPart_ContentSubmissionFragment\n}\n\nfragment RightFrameContentSubmissionComponent_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    id\n  }\n  definition {\n    __typename\n    status\n  }\n  ...RightFrameContentElement_ContentSubmissionFragment\n  ...contentSubmissionEnd_ContentSubmissionFragment\n}\n\nfragment RightFrameMultipleChoiceElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    id\n    typeDefinition {\n      __typename\n      definitionType\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        extension {\n          __typename\n          ... on LearnContentExtensionImpl {\n            configConsequences {\n              percentageRequiredToPass\n              isBlockedPermanentlyAfterNumFailedTries\n              isBlockedTemporarilyForNumDaysAfterOneFailedTry\n            }\n          }\n        }\n      }\n    }\n  }\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      progress {\n        __typename\n        percentage\n        ... on ActiveELearningContentSubmissionProgress {\n          isAtLastElement\n          numElements\n          currentElementIndex\n        }\n      }\n      currentElementState {\n        __typename\n        kind\n        ... on UntouchedElementState {\n          element {\n            __typename\n            id\n            ... on MultipleChoiceLearnElement {\n              question\n              answerOptions {\n                answer\n              }\n              ...wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment\n            }\n          }\n        }\n        ... on MultipleChoiceInputElementState {\n          element {\n            __typename\n            id\n            ... on MultipleChoiceLearnElement {\n              answerOptions {\n                answer\n              }\n              answeringType\n              ...wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment\n            }\n          }\n          checkedAnswerIndices\n        }\n      }\n    }\n  }\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment SubmitDisplayElementButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TextElementDisplay_TextElementV2Fragment on TextLearnElement {\n  text\n  title\n}\n\nfragment TextElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...TextElementDisplay_TextElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment VideoElementDisplay_VideoLearnElementFragment on VideoLearnElement {\n  videoFile {\n    url\n    id\n  }\n  subtitles {\n    subtitles {\n      startTimeInSec\n      endTimeInSec\n      text\n    }\n  }\n  title\n}\n\nfragment VideoElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...VideoElementDisplay_VideoLearnElementFragment\n          id\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment contentSubmissionEnd_ContentSubmissionFragment on ContentSubmission {\n  learnOpportunity {\n    id\n    nextContentNode {\n      structureDefinition {\n        __typename\n        title\n      }\n      typeDefinition {\n        __typename\n        ... on LearnOpportunityELearningContentTypeDefinition {\n          containedElementTypes\n        }\n      }\n      id\n    }\n    root {\n      id\n      structureDefinition {\n        __typename\n        title\n        ... on LearnOpportunityRootStructureDefinition {\n          extension {\n            __typename\n            ... on LearnOpportunityRootExtensionImpl {\n              configConsequences {\n                rewardExpired\n                showAnswerExpired\n              }\n            }\n          }\n        }\n      }\n      ...showAnswerButtonContainer_NodeFragment\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        extension {\n          __typename\n          ... on LearnContentExtensionImpl {\n            configConsequences {\n              percentageRequiredToPass\n            }\n          }\n        }\n        containedElementTypes\n        contentNodeAdvancementResult {\n          __typename\n          status\n          ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n            configResults {\n              __typename\n              configType\n              __isRestartIfFailedContentConfigResult: __typename\n              canBeRestarted\n              ... on NegativeBlockPermanentlyWhenRewardedRestartIfFailedContentConfigResult {\n                canBeRestarted\n              }\n              ... on NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult {\n                blockedUntil\n              }\n            }\n          }\n        }\n      }\n    }\n    ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n    ...NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment\n  }\n  lastUpdated\n  definition {\n    __typename\n    status\n    ... on FailedELearningContentSubmissionDefinition {\n      relativeProgress {\n        numCorrect\n        numElements\n        percentageCorrect\n      }\n    }\n    ... on PassedELearningContentSubmissionDefinition {\n      relativeProgress {\n        numCorrect\n        numElements\n        percentageCorrect\n      }\n      rewardResults {\n        __typename\n        kind\n        rewardKind\n        ... on PointsRewardWasPossibleResult {\n          amount\n          pointsPoolName\n        }\n        ... on CertificateRewardWasPossibleResult {\n          certificateName\n          issuedCertificate {\n            fileRef {\n              url\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n  ...moduleRating_ContentSubmissionFragment\n}\n\nfragment moduleRating_ContentSubmissionFragment on ContentSubmission {\n  learnOpportunity {\n    root {\n      id\n    }\n    id\n  }\n}\n\nfragment showAnswerButtonContainer_NodeFragment on LearnOpportunityV2 {\n  id\n  root {\n    id\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        id\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n          }\n        }\n        ...showAnswersButton_LearnOpportunityFragment\n      }\n    }\n    definitionType\n  }\n  ...showAnswersButton_LearnOpportunityFragment\n}\n\nfragment showAnswersButton_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      showAnswerElements {\n        __typename\n        id\n        elementType\n        ... on MultipleChoiceElementV2 {\n          question\n          answerOptions {\n            answer\n            isCorrect\n          }\n        }\n      }\n    }\n  }\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              showAnswerExpired\n              showAnswerFrom\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment on MultipleChoiceLearnElement {\n  question\n  image {\n    url\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    image {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf19237336776578efa1cceab486da16";

export default node;
